import { Title, useResourceContext } from 'react-admin';
import { useLocation } from 'react-router-dom';
import { getExpoName } from '../utils/expoName';

export const CustomTitle = () => {
  const resource = useResourceContext();
  const location = useLocation();
  const expoName = getExpoName();
  
  // Detect view type from URL
  const getViewType = () => {
    const pathname = location.pathname;
    
    // If URL ends with /create
    if (pathname.endsWith('/create')) {
      return 'Create';
    }
    
    // If URL ends with an ID (recordId for edit)
    // Example: /sessions/123, /sessions/abc123, /sessions/uuid-123 → Edit
    // Detects anything after the last slash that is not 'create'
    const pathParts = pathname.split('/');
    const lastPart = pathParts[pathParts.length - 1];
    
    if (lastPart && lastPart !== resource && lastPart !== 'create') {
      return 'Edit';
    }
    
    // Default is List (example: /sessions)
    return 'List';
  };
  
  // Capitalize first letter and make it more readable
  const formatResourceName = (resourceName: string, viewType: string) => {
    const capitalized = resourceName.charAt(0).toUpperCase() + resourceName.slice(1);
    
    // For Create and Edit, use singular form
    if (viewType === 'Create' || viewType === 'Edit') {
      // Remove 's' at the end if it exists (sessions → session, tags → tag, etc.)
      if (capitalized.endsWith('s') && capitalized.length > 1) {
        return capitalized.slice(0, -1);
      }
    }
    
    return capitalized;
  };
  
  // Format expo name: ana2025 → ANA_2025
  const formatExpoName = (name: string) => {
    // Split letters and numbers, add '_' between them, and uppercase letters
    return name.replace(/([a-zA-Z]+)(\d+)/, (match, letters, numbers) => {
      return letters.toUpperCase() + '_' + numbers;
    });
  };
  
  const viewType = getViewType();
  const resourceTitle = formatResourceName(resource, viewType);
  const formattedExpoName = formatExpoName(expoName);
  
  // Generate title with view type
  const title = `${formattedExpoName} - ${viewType} ${resourceTitle}`;
    
  return <Title title={title} />;
};
